export type CSVStats = {
  enroll: number;
  verify: number;
  move_out: number;
  resubscribe: number;
  unenroll: number;
  data_update: number;
  valid_count: number;
  invalid_count: number;
  itemized_errors?: { [key: string]: { count: number; description?: string } };
};

export type CsvUploadStatusResponse =
  | {
      id: number;
      status: CsvUploadStatus;
      stats: CSVStats;
      options: {
        enroll: boolean;
        opt_in: boolean;
        update: boolean;
        verify: boolean;
        moveout: boolean;
        opt_out: boolean;
        unenroll: boolean;
      };
      csv_filename?: string;
      result_csv_url?: string;
      updated_at: string;
      enrollments_by_state: Record<string, number>;
    }
  | undefined;

export enum CsvUploadStatus {
  Executing = "executing",
  Executed = "executed", // Shown only once.
  Parsed = "parsed",
  Parsing = "parsing", // when csv is being validated
  Init = "init", // Likely inaccessible for the front-end.

  // These should be used like idle
  Failed = "failed",
  Canceled = "canceled"
}
